<template>
  <div class="outerBox" :style="{ backgroundImage: 'url(' + imgPath + ')' }">
    <div class="outer_cont">
      <img src="@/assets/image/zc1.png" class="img_1" alt="">
      <div class="outer_one settingStyle" :style="'backgroundImage:url(' + require('@/assets/image/biank1.png') + ')'
        ">
        <div class="one_1">
          <img src="@/assets/image/zc2.png" class="one_1_img" alt="">
          <input type="number" v-model="phone" placeholder="Phone Number" class="one_1_input" style="max-width: 100%;">
        </div>
        <div class="one_1">
          <img src="@/assets/image/zc3.png" class="one_1_img" alt="">
          <input type="number" v-model="otp" placeholder="OTP" class="one_1_input">
          <div class="one_1_three" @click="obtainClick"> {{ obtain == 0 ? "Send" : obtain }} </div>
          <van-count-down ref="countDown" :time="60 * 1000" format="ss" :autoStart="false" @change="onChange"
            v-show="false">
          </van-count-down>
        </div>
        <div class="one_2" @click="register(1)">Got free ticket</div>
        <!-- <div class="one_3" @click="downLoad">Download APP</div> -->
      </div>
      <div class="outer_two settingStyle" :style="'backgroundImage:url(' + require('@/assets/image/biank2.png') + ')'
        ">
        <img src="@/assets/image/zc4.png" class="two_1" alt="">
        <div class="two_2">Real Kerala Lottery experience</div>
        <div class="two_3">We offer the official Kerala Lottery to bring you the purest Indian lottery experience</div>
        <img src="@/assets/image/zc7.png" class="two_4" alt="">
        <img src="@/assets/image/zc5.png" class="two_1" alt="">
        <div class="two_2">Randomness and fairness of the game</div>
        <div class="two_3">Completely random and fair drawing: All our games guarantee absolute randomness, and every
          drawing is a new opportunity!!</div>
        <img src="@/assets/image/zc7.png" class="two_4" alt="">
        <img src="@/assets/image/zc6.png" class="two_1" alt="">
        <div class="two_2">Gambling games and supplier reliability</div>
        <div class="two_3">Top gambling game suppliers: Our gambling games are provided by respected suppliers in the
          industry, ensuring that you get a fair and safe gaming environment.</div>
      </div>
    </div>
    <download :isDown="isDown" @mongolia="downLoad"></download>
  </div>
</template>
<script>
import { debounce } from '../utils/util'
/**
 * Created by www.xingnuocn.com
 * @title：注册
 * @author: 刘嘉鑫 
 * @version  V1.0 
 * @datecreate: 2023-11-29 14:16
 */
export default {
  data() {
    return {
      isDown: false, // 下载弹框

      imgPath: require("@/assets/image/bj.jpg"),
      phone: "", // 手机号
      otp: "", // 验证码

      obtain: "Send",
      time: 60,
      timeData: {},

      share_code: "",
      isShow: false,
    };
  },
  mounted() {
    this.share_code = this.$route.query.share_code; //用户id
    console.log(this.$client)
  },
  methods: {
    /**
     * 绑定奖品id
     * 刘义博
     * 2024-1-22
     */
    getjpID(id) {
      this.$request({
        url: '/Index/drawBindH5',
        data: {
          draw_id: id
        }
      }).then(res => {
        console.log('绑定成功', res);
        localStorage.removeItem('token')
      }).catch(err => {
        console.log('绑定失败', err);
      })
    },
    /**
     * 注册
     * 刘嘉鑫
     * 2022-11-26
     */
    register: debounce(function () {
      if (this.phone == "") {
        this.$toast({
          message: "Please enter your phone number",
          duration: 1500,
        });
        return;
      } else if (this.otp == "") {
        this.$toast({
          message: "Please enter the verification code",
          duration: 1500,
        });
        return;
      } else {
        if (this.isShow == true) {
          console.log('防止连点触发');
          return
        }
        this.isShow = true
        this.$request({
          url: "/Login/h5Register",
          data: {
            mobile: this.phone,
            captcha: this.otp,
            share_code: sessionStorage.getItem("share_code") == 'undefined' ? '' : sessionStorage.getItem("share_code"),// 邀请码
            type: '',
          },
        }).then((res) => {
          this.$toast({
            message: "Registered successfully",
            duration: 1500,
            forbidClick:true
          });
          localStorage.setItem("token", res.data.userinfo.token)
          setTimeout(() => {
            let bangding = JSON.parse(sessionStorage.getItem('Prize'))
            if (bangding) {
              this.getjpID(bangding.draw_id)
            }
            sessionStorage.removeItem('Prize')
            this.isShow = false
            this.downLoad()
            // this.$dialog.alert({
            //   message: `Register successfully, please download the APP`,
            //   confirmButtonText: "Download APP",
            //   theme: 'round-button',
            //   confirmButtonColor: "#005D35"
            // }).then(() => {
            //   this.isShow = false
            //   this.downLoad()
            // });
          }, 1500);
        }).catch((error) => {
          if (error.msg == 'Username already exist' || error.msg == 'Mobile already exist') {
            this.$dialog.alert({
              message: `${error.msg} please download the APP`,
              confirmButtonText: "Download APP",
              theme: 'round-button',
              confirmButtonColor: "#005D35"
            }).then(() => {
              this.downLoad()
            });
            return
          }
          this.$toast({
            message: error.msg,
            duration: 1500,
          });
          setTimeout(() => {
            this.isShow = false
          }, 1500)
        });
      }
    }, 400),

    /**
     * 获取验证码
     * 刘嘉鑫
     * 2022-5-11
     */
    obtainClick() {
      if (this.obtain != 0 && this.obtain != 'Send') {
        return
      }
      let that = this;
      if (this.phone == "") {
        this.$toast("Please enter your phone number");
        return;
      } else {
        this.$request({
          url: "/Common/sendCode",
          data: {
            mobile: this.phone,
            type: 2
          },
        }).then((res) => {
          console.log(res);
          this.$refs.countDown.start();
        }).catch((error) => {
          this.$toast({
            message: error.msg,
            duration: 1500,
            forbidClick:true,
          });
          if (error.code == 1111) {
            setTimeout(() => {
              this.$dialog.alert({
                message: `${error.msg} please download the APP`,
                confirmButtonText: "Download APP",
                theme: 'round-button',
                confirmButtonColor: "#005D35"
              }).then(() => {
                this.downLoad()
              });
            }, 1500)
          }
        });
      }
    },

    /**
     * 倒计时
     * 刘嘉鑫
     * 2023-11-29
     */
    onChange(e) {
      this.timeData = e;
      if (e.seconds == 0) {
        this.$refs.countDown.reset();
      }
      this.obtain = e.seconds;
    },

    /**
    * 下载
    * 刘嘉鑫
    * 2023-11-29
    */
    downLoad() {
      console.log("下载app");
      if (this.$client.QQ == true || this.$client.WEIXIN == true) {
        this.isDown = !this.isDown;
        return;
      } else {
        if (this.$client.ANDROID == true) {
          try {
            window.location.href = "https://keralagame.in/app/KeralaLottery.apk";
            console.log("安卓");
          } catch (e) { }
        }
        if (this.$client.IPHONE == true) {
          try {
            // window.location.href = "https://apps.apple.com/cn/app/随点达/id6451131075";
            console.log("ios");
            return;
          } catch (e) { }
        }
      }
    },

    /**
     * 关闭蒙层
     * 刘嘉鑫
     * 2023-11-29
     */
    mongolia() {
      this.isShow = false;
    },

    redirectToGooglePlay() {
      return
      // 替换下面的 "your_app_package_id" 为你应用的包名（package ID）
      const appPackageId = "";

      // 使用 window.location.href 或者 window.open 来跳转到 Google Play 商店
      window.location.href = `https://play.google.com/store/apps/details?id=${appPackageId}`;
      // 或者
      // window.open(`https://play.google.com/store/apps/details?id=${appPackageId}`, '_blank');
    }
  },
};
</script>
<style lang='scss' scoped>
.outerBox {
  // background: url("~@/assets/image/yaoqingyonghu.png");
  // width: 100%;
  height: 100%;
  // position: fixed;
  background-size: 100% 100%;
  // display: flex;
  // justify-content: center;
  padding: 44px 28px;

}

.img_1 {
  height: 650px;
  margin: 0 auto 48px;
}

.outer_one {
  // border: 4px solid #FFB400;
  // background: linear-gradient(135deg, #2BAC69 0%, #22B35C 100%);
  border-radius: 20px;
  padding: 50px;
  margin-bottom: 20px;

  .one_1 {
    display: flex;
    align-items: center;
    padding: 32px 60px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 100%);
    box-shadow: 0px 6px 0px 0px #197A51;
    border-radius: 50px;
    margin-bottom: 44px;

    .one_1_img {
      width: 36px;
      height: 36px;
      margin-right: 30px;
    }

    .one_1_input {
      font-size: 28px;
      font-weight: 400;
      color: #006A3D;
      border: none;
      background: transparent;
      max-width: 66%;
      outline: none;
    }

    .one_1_three {
      font-size: 28px;
      font-weight: bold;
      color: #AE3231;
      margin-left: auto;
    }
  }

  .one_2 {
    background: linear-gradient(0deg, #FFB400 0%, #FFF100 100%);
    box-shadow: 0px 6px 0px 0px #784100;
    border-radius: 50px;
    padding: 32px 0;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #006A3D;
  }

  .one_3 {
    background: linear-gradient(0deg, #269669 0%, #217654 100%);
    box-shadow: 0px 6px 0px 0px #217654;
    border-radius: 50px;
    padding: 32px 0;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    margin-top: 30px;
  }
}

.outer_two {
  border-radius: 40px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;

  .two_1 {
    width: 96px;
    height: 96px;
    margin-bottom: 32px;
  }

  .two_2 {
    font-size: 28px;
    font-weight: bold;
    color: #FFFFFF;
    background: linear-gradient(0deg, #FFB400 0%, #FFF100 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 20px;
  }

  .two_3 {
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 32px;
    opacity: 0.8;
    width: 90%;
  }

  .two_4 {
    width: 100%;
    height: 26px;
    margin: 35px 0 40px;
  }
}

.outer_cont {
  padding-bottom: calc(constant(safe-area-inset-bottom) + 140px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 140px);
}

.outer_fixed {
  padding: 30px 28px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 30px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 30px);
  background: linear-gradient(0deg, #256650 0%, #157F51 100%);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  flex-direction: row;

  .fixed_1 {
    width: 100px;
    height: 100px;
    background: #FFFFFF;
    border-radius: 20px;
    margin-right: auto;
    border: 2px solid #ffffff;
  }

  .fixed_2 {
    background: rgba(255, 255, 255, .5);
    border-radius: 100px;
    display: flex;
    align-items: center;
    padding: 20px 30px;
    margin-left: 30px;
    width: 22%;

    img {
      width: 50px;
      height: 50px;
      margin-right: 8px;
    }

    div {
      font-size: 24px;
      font-weight: 400;
      color: #222222;
      text-align: left;
    }
  }
}
</style>